var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fill-height"},[_c('v-row',{attrs:{"justify":"space-around"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"4"}},[_c('span',[_vm._v("SSO - Logging in, hold on please.")]),_vm._v(" "),_c('br')])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }